module.exports = __webpack_public_path__ + "img/gameTronos11.01d92c42.jpg";